import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';
import ptBr from './i18n/pt-br';

i18next.addResourceBundle('pt-br', 'estoque', ptBr);
i18next.addResourceBundle('en', 'estoque', en);

const EstoqueConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/suprimentos/estoque',
      component: React.lazy(() => import('./Estoque')),
    },
  ],
};

export default EstoqueConfig;
